import { TableProvider } from '@/modules/drivers/context/TableContext'
import React from 'react'
import { useParams } from 'react-router-dom'
import CardHistoryHeader from './components/CardHistoryHeader'
import ModalLayout from '@/modules/drivers/modals/shared/ModalLayout'
import {
  selectLoading,
  useLoadingStore,
} from '@/modules/shared/stores/loadingStore'
import { LoaderIcon } from '@/app/features/icons/Loader'
import { useDrivers } from '@/modules/shared/context/drivers/DriversContext'
import CardHistoryTable from './components/CardHistoryTable'
import CardHistoryFooter from './components/CardHistoryFooter'

const CardHistoryModal = ({ handleClose, companyId, driverId }) => {
  const globalLoading = useLoadingStore(selectLoading)


  const { basicDrivers } = useDrivers()
  const driverName = basicDrivers.find(
    (d) => String(d.id) === String(driverId),
  )?.fullName


  const { year: yearParam } = useParams<{ year?: string }>()
  const year = /^\d{4}$/.test(yearParam ?? '')
    ? yearParam
    : String(new Date().getFullYear())
  const dateFrom = `${year}-01-01`
  const dateTo = `${year}-12-31`

  return (
    <ModalLayout customZIndex={9999}>
      <div className="tw-relative tw-flex tw-h-fit tw-max-h-[90vh] tw-w-full tw-max-w-[90vw] tw-flex-col tw-rounded-lg tw-bg-white tw-shadow-2xl">
        {globalLoading && (
          <div className="tw-absolute tw-inset-0 tw-z-[200] tw-grid tw-place-items-center tw-rounded-lg tw-bg-black/30 tw-backdrop-blur-sm">
            <LoaderIcon className="tw-animate-spin" />
          </div>
        )}
        <CardHistoryHeader handleClose={handleClose} />
        <div className="tw-min-h-0 tw-flex-1 tw-overflow-auto">
          <TableProvider>
            <CardHistoryTable
              companyId={companyId}
              dateFrom={dateFrom}
              dateTo={dateTo}
              driverName={driverName}
            />
          </TableProvider>
        </div>
        <CardHistoryFooter handleClose={handleClose} />
      </div>
    </ModalLayout>
  )
}

export default CardHistoryModal
